const Glide = require('@glidejs/glide')
import Swiper, { Navigation } from 'swiper'

Swiper.use([Navigation])

class Category {
	constructor() {
		this.glideMedia()
		this.swiperMenu()
	}

	glideMedia() {
		try {
			if (document.querySelector('#glideMedia')) {
				new Glide.default('#glideMedia', {
					type: 'carousel',
					startAt: 0,
					perView: 1,
					autoplay: 5000,
					animationDuration: 150,
				}).mount()
			}
		} catch (error) {
			console.log('Category.glideMedia', { message: error.message })
		}
	}

	swiperMenu() {
		try {
			let menu = document.querySelector('.menu-wrap')

			let parentMenu = menu?.querySelector('.parent')
			let childMenu = menu?.querySelector('.child')
			let childrenMenu = menu?.querySelector('.children')

			let widthChildrentMenu = menu?.clientWidth - (childMenu?.clientWidth + (parentMenu ? parentMenu.clientWidth : 0)) - 70

			Object.assign(childrenMenu.style, {
				width: widthChildrentMenu + 'px',
			})

			new Swiper('#slide-menu', {
				loop: true,
				slidesPerView: 'auto',
				centeredSlides: false,
				slidesPerGroup: 1,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				on: {
					init: function () {
						childrenMenu?.classList.remove('hidden')
					},
				},
			})
		} catch (error) {
			console.log('Category.swiperMenu', { message: error.message })
		}
	}
}

export default window.addEventListener('DOMContentLoaded', function (evt) {
	new Category()
})
